import { render, staticRenderFns } from "./CmgMealCard.vue?vue&type=template&id=489eb8a0&scoped=true&lang=pug&"
import script from "./cmg-meal-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-meal-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgMealCard.vue?vue&type=style&index=0&id=489eb8a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489eb8a0",
  null
  
)

export default component.exports